import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsTableComponent } from './components/notifications-table/notifications-table.component';
import { NotificationService } from './services/notification.service';
import { INotification } from './models/notification';
import { AlertService } from '@shared/services/alert.service';
import { AlertType } from '@utils/enums/alert-type';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [CommonModule, NotificationsTableComponent],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css',
})
export class NotificationsComponent implements OnInit {
  private readonly notificationSrv: NotificationService = inject(NotificationService);
  private readonly alertSrv: AlertService = inject(AlertService);

  public notifications: INotification[] = [];
  public isLoading: boolean = true;

  ngOnInit(): void {
    this.loadNotifications();
    
    // Escuchar cambios en las notificaciones para recargar automáticamente
    this.notificationSrv.notification$.subscribe(() => {
      this.loadNotifications();
    });
  }

  loadNotifications(): void {
    this.isLoading = true;
    this.notificationSrv.getNotifications().subscribe({
      next: (response) => {
        if (response.ok && response.data?.notificationResponse) {
          this.notifications = response.data.notificationResponse;
        } else {
          this.alertSrv.showAlert({
            alertType: AlertType.ERROR,
            mainMessage: 'Error al cargar las notificaciones',
          });
        }
        this.isLoading = false;
      },
      error: () => {
        this.alertSrv.showAlert({
          alertType: AlertType.ERROR,
          mainMessage: 'Error al cargar las notificaciones',
        });
        this.isLoading = false;
      },
    });
  }

}